import { createSlice } from '@reduxjs/toolkit';

const commentSlice = createSlice({
  name: 'comments',
  initialState: {
    // guarda comentarios agrupados por página
    byPage: {
      // [pageNumber]: [ { id, xRatio, yRatio, text, author, timestamp } ]
    }
  },
  reducers: {
    setComments(state, action) {
      // payload: { [page]: [ ...comentarios ] }
      state.byPage = action.payload;
    },
    addComment(state, action) {
      // payload: { page, comment }
      const { page, comment } = action.payload;
      if (!state.byPage[page]) state.byPage[page] = [];
      state.byPage[page].push(comment);
    }
  }
});

export const { setComments, addComment } = commentSlice.actions;
export default commentSlice.reducer;
